export class CalibrationStatus {
    public id: number
    public name: string
}

export class CalibrationStatusWithPreviousState extends CalibrationStatus {
    public previousStatus: CalibrationStatus
}
